import React from "react";
import Heading from "../Heading";
import { ProductStyles } from "./Styles";
import { Box, Divider } from "@mui/material";
import GlobalSubHeading from "../GlobalSubHeading";
import { getMeaning } from "../../utils/localization";

const TopProducts = () => {
  return (
    <Box sx={ProductStyles.MainBannerBox}>
      <Box align="center" sx={{}}>
        <Heading title={getMeaning("PRDCTS.HDNG")} />
      </Box>

      <Box align="center">
        <GlobalSubHeading subTitle={getMeaning("PRDCTS.SBHDNG")} />
      </Box>
      {/* <Typography
        sx={[
          HomeBannerStyles.bannerTitle,
          { width: { xs: "100%", sm: "90%", md: "80%" } },
        ]}
      >
        {getMeaning("PRDCTS.HDNG")}
      </Typography> */}

      {/* <Box align="center">
        <Typography
          sx={[
            HomeBannerStyles.bannerDescription,
            {
              textAlign: "justify",
              width: { xs: "100%", sm: "90%", md: "80%" },
            },
          ]}
        >
          {getMeaning("PRDCTS.SBHDNG")}
        </Typography>
      </Box> */}

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          my: 4,
        }}
      >
        <Box
          component="img"
          alt=""
          src="images/Products/CircularCompAnimation.svg"
          sx={{
            width: {
              xs: "75%", // Mobile
              sm: "45%", // Small tablets
              md: "35%", // Medium devices
              lg: "30%", // Large desktops
              xl: "35%", // Extra large screens
            },
            maxWidth: "100%",
            height: "auto",
            display: "block",
          }}
        />
      </Box>

      <Box align="center">
        <GlobalSubHeading subTitle={getMeaning("PRDCTS.DSCRPTN")} />
      </Box>

      {/* <Box align="center">
        <Typography
          sx={[
            ProductStyles.SubHeadingTxt,
            {
              textAlign: "justify",
              width: { xs: "100%", sm: "90%", md: "80%" },
            },
          ]}
        >
          {getMeaning("PRDCTS.DSCRPTN")}
        </Typography>
      </Box> */}

      <Divider sx={ProductStyles.DividerBar} />

      <Box align="center">
        <GlobalSubHeading subTitle={getMeaning("PRDCTS.SBDSCRPTN1")} />
      </Box>

      {/* <Box align="center">
        <Typography
          sx={[
            HomeBannerStyles.bannerDescription,
            {
              textAlign: "justify",
              width: { xs: "100%", sm: "90%", md: "80%" },
            },
          ]}
        >
          {getMeaning("PRDCTS.SBDSCRPTN1")}
        </Typography>
      </Box> */}

      <Box align="center">
        <GlobalSubHeading subTitle={getMeaning("PRDCTS.SBDSCRPTN2")} />
      </Box>

      {/* <Box align="center">
        <Typography
          sx={[
            HomeBannerStyles.bannerDescription,
            {
              textAlign: "justify",
              width: { xs: "100%", sm: "90%", md: "80%" },
            },
          ]}
        >
          {getMeaning("PRDCTS.SBDSCRPTN2")}
        </Typography>
      </Box> */}

      <Divider sx={ProductStyles.DividerBar} />
    </Box>
  );
};

export default TopProducts;
